module.exports = __webpack_public_path__ + "media/acuity/affinity_logo-9144b991.svg";